// LUD Copilot support chat. Mirrors lud-backend/errorCatalog/support.js.
const supportMessages = {
  AI_DISABLED: { en: "The AI assistant is not available right now.", ar: "المساعد الذكي غير متاح حاليًا." },
  ATTACHMENT_UNAVAILABLE: { en: "One or more attachments are invalid or were already used.", ar: "مرفق واحد أو أكثر غير صالح أو سبق استخدامه." },
  INVALID_SESSION: { en: "Your session is not valid. Please sign in again.", ar: "جلستك غير صالحة. يرجى تسجيل الدخول مرة أخرى." },
  LIMIT_REACHED: { en: "The maximum of {max} entries has been reached.", ar: "تم الوصول إلى الحد الأقصى وهو {max}." },
  STATUS_CHANGED: { en: "The status changed meanwhile. Refresh and try again.", ar: "تغيّرت الحالة في الأثناء. حدّث الصفحة وحاول مرة أخرى." },
  SYSTEM_FAQ: { en: "System questions can't be deleted. Deactivate them instead.", ar: "لا يمكن حذف الأسئلة الأساسية للنظام. يمكنك تعطيلها بدلًا من ذلك." },
};

export default supportMessages;
